import DataTable from 'datatables.net-dt';

export default {
  init() {
    // JavaScript to be fired on the home page

    new DataTable('#study-filter', {
      order: [0, 'asc'],
      pageLength: 25,
      language: {
        searchPlaceholder: 'Search...',
      },
      // scrollToTop: true,
      // colReorder: true,
      // buttons:['createState', 'savedStates', 'removeAllStates'],
    });
    $('div#study-filter_length, #study-filter_filter').wrapAll('<div class="dataTables_wrapper"><div class="dataTables_filters"></div></div>');

  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};







// WEBPACK FOOTER //
// ./scripts/routes/studiesFilter.js